// @flow
import { Map, fromJS } from "immutable";

export const contactsSelector = (state: Map<string, any>) => {
  return state.getIn(["contact", "contacts"])
}

export const allContactsSelector = (state: Map<string, any>) => {
  let contacts = contactsSelector(state)
  if(!contacts.size) {
    fromJS([]);
  } else {
    contacts = contacts.toJS().reverse();
    return fromJS(contacts)
  }
}

export const contactErrorSelector = (state: Map<string, any>) =>
  state.getIn(["contact", "error"]);

export const allContactEmailsSelector = (state: Map<string, any>) =>
  contactsSelector(state).map(contact => contact.get("email"))



// WEBPACK FOOTER //
// ./src/features/contact/store/contactsSelectors.js